const menuData = [
  {
    title: "Home",
    link: "/",
  },
  {
    title: "Our Philosophy",
    link: "/About",
  },
  {
    title: "The Shoppe",
    megaMenu: true,
    categories: [
      {
        title: "Rudrakshas",
        slug: "rudrakshas",
        icon: "https://i.pinimg.com/1200x/0b/0a/90/0b0a909eb7a1c3854f734240d5da1b03.jpg",
        items: [
          {
            title: "By Mukhi (1-14 Mukhi)",
            slug: "by-mukhi",
            image:
              "https://i.pinimg.com/1200x/64/a4/43/64a443c590c8d6844a4ac7fe15ad5f4d.jpg",
          },
          {
            title: "15-24 Mukhi",
            slug: "15-24-mukhi",
            image:
              "https://i.pinimg.com/1200x/44/ba/29/44ba29eddf1f9866bc3280d821ff3e4b.jpg",
          },
          {
            title: "Rudraksha Malas",
            slug: "rudraksha-malas",
            image:
              "https://i.pinimg.com/1200x/6c/61/2c/6c612c0456eba3182a2e4a0dc196099f.jpg",
          },
          {
            title: "Combination Malas",
            slug: "combination-malas",
            image:
              "https://i.pinimg.com/1200x/22/60/f1/2260f131bee4b8d0e9e9abdc25ac9d55.jpg",
          },
          {
            title: "Premium Nepali Rudraksha",
            slug: "premium-nepali-rudraksha",
            image:
              "https://i.pinimg.com/736x/0e/27/ee/0e27ee61ef0347226a66ae551f5c4eb4.jpg",
          },
          {
            title: "Indonesian Rudraksha",
            slug: "indonesian-rudraksha",
            image:
              "https://i.pinimg.com/1200x/35/5b/01/355b0155b635e6f2a61049a18bf38862.jpg",
          },
          {
            title: "Rudraksh Bracelets",
            slug: "rudraksh-bracelets",
            image:
              "https://i.pinimg.com/1200x/22/b7/be/22b7be60dcc678438d401dc140624fbd.jpg",
          },
          {
            title: "Rudraksha Consultation",
            slug: "rudraksha-consultation",
            image:
              "https://i.pinimg.com/1200x/22/b5/89/22b589ccfcf45eaa92e68c249b7b6b60.jpg",
          },
          {
            title: "Rudraksha Calculator",
            slug: "rudraksha-calculator",
            link: "/rudraksha-calculator",
          },
        ],
      },
      // 2 Shivling
      {
        title: "Shivling",
        slug: "shivling",
        icon: "https://i.pinimg.com/1200x/5d/bd/c9/5dbdc9f7acb9e2e9fbcab10cdc3fd20d.jpg",

        items: [
          {
            title: "By Material",
            slug: "by-material",
            image:
              "https://i.pinimg.com/736x/36/94/32/3694323cdf208b35b487b2a83c1bae50.jpg",
          },
          {
            title: "By Size",
            slug: "by-size",
            image:
              "https://i.pinimg.com/1200x/f5/f3/20/f5f32077db3434aa99f47c9ed6499edc.jpg",
          },
          {
            title: "Shivling Sets",
            slug: "shivling-sets",
            image:
              "https://i.pinimg.com/1200x/42/d1/e5/42d1e513069cdea6f7f8ec69451f8945.jpg",
          },
          {
            title: "Accessories",
            slug: "accessories",
            image:
              "https://i.pinimg.com/1200x/46/bf/20/46bf20450adad1835bd999c487f3856f.jpg",
          },
        ],
      },
      // 3 Shankh & Sea Shells
      {
        title: "Shankh & Sea Shells",
        slug: "shankh-sea-shells",
        icon: "https://i.pinimg.com/1200x/bc/91/61/bc9161a5f2dcbc92fb6f21f150773f08.jpg",

        items: [
          {
            title: "Dakshinavarti Shankh",
            slug: "dakshinavarti-shankh",
            image:
              "https://i.pinimg.com/1200x/2f/cb/1c/2fcb1cebfd4dbc8a214123306af543ec.jpg",
          },
          {
            title: "Vamavarti Shankh",
            slug: "vamavarti-shankh",
            image:
              "https://i.pinimg.com/1200x/36/1b/9d/361b9d7c84c4ed382e732b9d65b8340e.jpg",
          },

          {
            title: "Ganesh Shankh",
            slug: "ganesh-shankh",
            image:
              "https://i.pinimg.com/736x/fa/e2/dd/fae2ddad54551d8b07c46bbbcca633ae.jpg",
          },
          {
            title: "Moti Shankh",
            slug: "moti-shankh",
            image:
              "https://i.pinimg.com/1200x/f6/04/19/f6041911426e4bb55b478706fd9f441e.jpg",
          },
          {
            title: "Silver-Plated Shankh",
            slug: "silver-plated-shankh",
            image:
              "https://i.pinimg.com/736x/b7/9f/5e/b79f5e5e449597637e7b1e0210c9360b.jpg",
          },
          {
            title: "Carved Shankh",
            slug: "carved-shankh",
            image:
              "https://i.pinimg.com/1200x/e8/c4/77/e8c477fb140fd5889bb39d28773d0d29.jpg",
          },
          {
            title: "Abhishek / Puja Shankh",
            slug: "abhishek-puja-shankh",
            image:
              "https://i.pinimg.com/1200x/e5/76/ad/e576ad51bf5f34a6a2a55f6d61e34e29.jpg",
          },

          {
            title: "Kaudi & Gomati Chakra",
            slug: "kaudi-gomati-chakra",
            image:
              "https://i.pinimg.com/1200x/06/e2/38/06e23899276229a96eafb6bd338c727f.jpg",
          },
          // {
          //   title: "Heera Shankh",
          //   slug: "heera-shankh",
          // },

          {
            title: "Shankh Accessories",
            slug: "shankh-accessories",
            image:
              "https://i.pinimg.com/1200x/31/36/2e/31362e50d1d9671cdf64a4e81c3aa2cb.jpg",
          },
        ],
      },
      //4 Shaligram
      {
        title: "Shaligram",
        slug: "shaligram",
        icon: "https://i.pinimg.com/736x/0e/6b/5d/0e6b5d4b7dfe58083bf6be85f1125db4.jpg",

        items: [
          {
            title: "Laxmi Narayan Shaligram",
            slug: "laxmi-narayan-shaligram",
            image:
              "https://i.pinimg.com/1200x/2b/34/9a/2b349a2bfc899fc22e7e663e43640db7.jpg",
          },
          {
            title: "Vishnu Avatars",
            slug: "vishnu-avatars",
            image:
              "https://i.pinimg.com/1200x/25/09/4e/25094ee2aa0abc20d10ebd687014783c.jpg",
          },
          {
            title: "Sudarshan Shaligram",
            slug: "sudarshan-shaligram",
            image:
              "https://i.pinimg.com/1200x/2e/bc/5c/2ebc5c3674e1803d4d90e25e6e52331a.jpg",
          },
          {
            title: "Shivlings / Harihara Shaligram",
            slug: "shivlings-harihara-shaligram",
            image:
              "https://i.pinimg.com/1200x/26/23/64/262364b9bdf91b54def9fb8f5fb23c43.jpg",
          },
          {
            title: "Small Shaligram",
            slug: "small-shaligram",
            image:
              "https://i.pinimg.com/1200x/15/d5/1c/15d51cea8343fc7fec6b895f2f47c691.jpg",
          },
          {
            title: "Large Shaligram",
            slug: "large-shaligram",
            image:
              "https://i.pinimg.com/736x/e4/ea/b5/e4eab54d62ef0143e5ba68f1ae24f867.jpg",
          },
          {
            title: "Shaligram Set",
            slug: "shaligram-set",
            image:
              "https://i.pinimg.com/736x/bf/3b/9d/bf3b9d4164879931f8f074adc365a8c6.jpg",
          },
        ],
      },
      // 5 Gemstones
      {
        title: "Gemstones",
        slug: "gemstones",
        icon: "https://i.pinimg.com/1200x/5d/52/72/5d5272e5cb68c2e77a10a2a4315e710b.jpg",

        items: [
          {
            title: "Precious Gemstones",
            slug: "precious-gemstones",
            image:
              "https://i.pinimg.com/736x/ec/35/43/ec3543cb7a7e776e5cd688cc3d6f4478.jpg",
          },
          {
            title: "Semi-Precious Gemstones",
            slug: "semi-precious-gemstones",
            image:
              "https://i.pinimg.com/1200x/91/70/36/91703673518ee3dab7a12d8f989110b3.jpg",
          },
          {
            title: "By Planet",
            slug: "by-planet",
            image:
              "https://i.pinimg.com/736x/49/38/f1/4938f170383a1e91c203fd80a843603e.jpg",
          },
          {
            title: "Rings & Pendants",
            slug: "rings-pendants",
            image:
              "https://i.pinimg.com/736x/22/e2/c2/22e2c2a642a742d57fdd81e56492b2a5.jpg",
          },
          {
            title: "Customize Your Product",
            slug: "customize-your-product",
            image:
              "https://i.pinimg.com/1200x/2b/20/ed/2b20ed4021922a6d3248f384a85859b7.jpg",
          },
          {
            title: "Gemstone Consultation",
            slug: "gemstone-consultation",
            image:
              "https://i.pinimg.com/1200x/6f/86/cc/6f86cc8fdeb45f84e83f34fc7bd398e2.jpg",
          },
        ],
      },
      //6   Crystals & Healing Stones
      {
        title: "Crystals & Healing Stones",
        slug: "crystals",
        icon: "https://i.pinimg.com/1200x/85/05/96/85059645c38dd06ccbbc32fc34ad8367.jpg",

        items: [
          {
            title: "Tumbled Stones",
            slug: "tumbled-stones",
            image:
              "https://i.pinimg.com/1200x/dc/2e/bf/dc2ebf841d548c9b4442d81986704b1f.jpg",
          },

          // 2. Crystal Jewelry
          {
            title: "Crystal Jewelry",
            slug: "crystal-jewelry",
            image:
              "https://i.pinimg.com/1200x/2c/1f/3f/2c1f3fa2ab8d260d0a74cf89b16cdc06.jpg",
          },

          // 3. Home Decor & Energy Cleansing
          {
            title: "Home Decor & Energy Cleansing",
            slug: "home-decor-energy-cleansing",
            image:
              "https://i.pinimg.com/736x/11/f7/c8/11f7c8659640fb1bedbfe79597249f3e.jpg",
          },

          {
            title: "Intention & Benefit",
            slug: "intention-benefit",
            image:
              "https://i.pinimg.com/736x/97/a2/1e/97a21e9bdefe37b1f79aed3f452192ef.jpg",
          },

          // 5. Customize Product
          {
            title: "Customize Your Own Product",
            slug: "customize-your-own-product",
            image:
              "https://i.pinimg.com/1200x/c9/01/27/c90127da78459d6182d494ab4823c775.jpg",
          },

          // 6. Crystal Consultation
          {
            title: "Crystal Consultation",
            slug: "crystal-consultation",
            image:
              "https://i.pinimg.com/736x/6d/35/1b/6d351b221c8aeaf9adb7dcf605395c9b.jpg",
          },
        ],
      },

      // 7 Vastu Products
      {
        title: "Vastu Shashtra Products",
        slug: "vastu-products",
        icon: "https://i.pinimg.com/1200x/a4/a7/c5/a4a7c566132d7be6e5b3356a32e27cd3.jpg",

        items: [
          {
            title: "Frequently Used",
            slug: "frequently-used",
            image:
              "https://i.pinimg.com/1200x/fe/8d/ec/fe8deca5225ffe5399604cffef73c522.jpg",
          },
          {
            title: "Vastu Pyramids",
            slug: "vastu-pyramids",
            image:
              "https://i.pinimg.com/736x/9c/fd/d6/9cfdd667bf8ab984e308b32f49957d2c.jpg",
          },
          {
            title: "Vastu Yantras",
            slug: "vastu-yantras",
            image:
              "https://i.pinimg.com/1200x/c0/8f/6e/c08f6e8bae54309b0eb22ea9daeac149.jpg",
          },
          {
            title: "Vastu Energy Remedies",
            slug: "vastu-energy-remedies",
            image:
              "https://i.pinimg.com/1200x/42/2b/47/422b474121375113c87964bf1fe63132.jpg",
          },
          {
            title: "Crystal Vastu Remedies",
            slug: "crystal-vastu-remedies",
            image:
              "https://i.pinimg.com/1200x/b6/21/a9/b621a980599676c31bb7cfb476788f28.jpg",
          },
          {
            title: "Entrance & Protection",
            slug: "entrance-protection",
            image:
              "https://i.pinimg.com/1200x/ff/8d/07/ff8d07cfbea61607efbb75606538b522.jpg",
          },
          {
            title: "Wealth & Prosperity",
            slug: "wealth-prosperity",
            image:
              "https://i.pinimg.com/736x/80/a7/96/80a7960149d5c2a350e5988e144bdc91.jpg",
          },
          {
            title: "Water Element Remedies",
            slug: "water-element-remedies",
            image:
              "https://i.pinimg.com/1200x/b3/e3/d7/b3e3d7850b65d5c605003f064266c2cc.jpg",
          },
          {
            title: "Wall Décor & Paintings",
            slug: "wall-decor-paintings",
            image:
              "https://i.pinimg.com/736x/75/fa/85/75fa8562cef7084d8f8a09a212b4008c.jpg",
          },
          {
            title: "Direction-Based Remedies",
            slug: "direction-based-remedies",
            image:
              "https://i.pinimg.com/1200x/f5/53/8c/f5538cab5bc7413afc92ffad836629af.jpg",
          },
          {
            title: "Vastu for Home",
            slug: "vastu-for-home",
            image:
              "https://i.pinimg.com/736x/1a/ab/1e/1aab1eebdb86834df48cf776f0e8d40e.jpg",
          },
          {
            title: "Vastu for Business",
            slug: "vastu-for-business",
            image:
              "https://i.pinimg.com/1200x/f1/a4/21/f1a4216de7d0e6bd5215ecf17aa305e1.jpg",
          },
          {
            title: "Sacred Metals",
            slug: "sacred-metals",
            image:
              "https://i.pinimg.com/1200x/e9/11/fc/e911fc75dd37f29c41ab71c2496898a5.jpg",
          },
        ],
      },
      // 8 Pooja Essentials
      {
        title: "Pooja Essentials",
        slug: "pooja",
        icon: "https://i.pinimg.com/736x/6e/fe/c6/6efec6019019c9034ae371fbcc58ea79.jpg",

        items: [
          {
            title: "Daily Pooja Essentials",
            slug: "daily-pooja-essentials",
            image:
              "https://i.pinimg.com/1200x/f2/7a/49/f27a49d9b522e98d25a276a08c77701e.jpg",
          },
          {
            title: "Diyas & Deepam",
            slug: "diyas-deepam",
            image:
              "https://i.pinimg.com/1200x/e1/c1/34/e1c134a252aee51c6abcb7a7bb82da43.jpg",
          },
          {
            title: "Pooja Thali Collection",
            slug: "pooja-thali",
            image:
              "https://i.pinimg.com/1200x/f7/b9/89/f7b9896ffe39078c05e942994b30cce3.jpg",
          },
          {
            title: "Pooja Utensils",
            slug: "pooja-utensils",
            image:
              "https://i.pinimg.com/736x/e5/5c/ef/e55cef38085cfb08570f6006e9b426cb.jpg",
          },
          {
            title: "Havan & Yagya Samagri",
            slug: "havan-yagya-samagri",
            image:
              "https://i.pinimg.com/1200x/63/5c/58/635c58205edaedd38352cea9d5ae43a0.jpg",
          },
          {
            title: "Idols & Murti",
            slug: "idols-murti",
            image:
              "https://i.pinimg.com/1200x/2a/cb/b8/2acbb854ea693e6ae84b1f9c4d451508.jpg",
          },
          {
            title: "Festival Specials",
            slug: "festival-specials",
            image:
              "https://i.pinimg.com/1200x/57/ca/71/57ca71cd7234c653f643deb0209a6f8d.jpg",
          },
          {
            title: "Spiritual Fragrance",
            slug: "spiritual-fragrance",
            image:
              "https://i.pinimg.com/736x/e5/c8/5f/e5c85f2f6e3b79b8eaf247517f513b71.jpg",
          },
          {
            title: "Sacred Water & Liquids",
            slug: "sacred-water-liquids",
            image:
              "https://i.pinimg.com/1200x/a6/f9/b4/a6f9b498907c6f489eaa9c500b2e3590.jpg",
          },
          {
            title: "Puja Asanas",
            slug: "puja-asanas",
            image:
              "https://i.pinimg.com/1200x/3f/22/ce/3f22ceef2719a9c5ee0aeede9948bbaf.jpg",
          },
         
        ],
      },
      //  Perfumes & Fragrances
      {
        title: "Perfumes & Fragrances",
        slug: "perfumes",
        icon: "https://i.pinimg.com/736x/7b/a7/5d/7ba75d25419496c0b51877e280e0da26.jpg",

        items: [
          {
            title: "Traditional Attar",
            slug: "traditional-attar",
            image: "https://i.pinimg.com/1200x/24/d9/c0/24d9c05f4f14a84c29020ba8b10f9ad8.jpg",
          },
          {
            title: "Solid Perfumes",
            slug: "solid-perfumes",
            image: "https://i.pinimg.com/736x/d7/98/99/d79899834b54ef68f146184d9e7b5698.jpg",
          },
          {
            title: "Non-Alcoholic Fragrance Mist",
            slug: "non-alcoholic-fragrance-mist",
            image: "https://i.pinimg.com/736x/22/10/21/2210216f330e51d16c5b7947289a5521.jpg",
          },
          {
            title: "Room Fresheners",
            slug: "room-fresheners",
            image: "https://i.pinimg.com/736x/12/5e/06/125e0645dfff280c9d5ed555adc54fb7.jpg",
          },
          {
            title: "Fragrance for Men",
            slug: "fragrance-for-men",
            image: "https://i.pinimg.com/1200x/d8/a5/77/d8a577779537f051300dbc37664acd8a.jpg",
          },
          {
            title: "Fragrance for Women",
            slug: "fragrance-for-women",
            image: "https://i.pinimg.com/736x/08/f6/4c/08f64cced91a1fd71fafe45e208448a9.jpg",
          },
          {
            title: "Unisex Fragrance",
            slug: "unisex-fragrance",
            image: "https://i.pinimg.com/1200x/df/c5/04/dfc504f914d8ca2ffec6b8f104adf2ca.jpg",
          },
          {
            title: "Fragrance for Car",
            slug: "fragrance-for-car",
            image: "https://i.pinimg.com/1200x/ab/b7/4f/abb74f4db1946e8cd86de408fe1953c6.jpg",
          },
        ],
      },
    
      // 9 Tulsi Product
      {
        title: "Tulsi, Chandan & Other Wood Products",
        slug: "tulsi",
        icon: "https://i.pinimg.com/1200x/4e/9d/08/4e9d086c6169747cc307af7297acfa05.jpg",

        items: [
           {
            title: "Special Varieties",
            slug: "special-varieties",
            image:
              "https://i.pinimg.com/1200x/89/c2/ed/89c2ede9b2fa9c6b5df7919cd76c8f07.jpg",
          },
          {
            title: "Kanthi Malas",
            slug: "kanthi-malas",
            image:
              "https://i.pinimg.com/1200x/ad/70/4e/ad704e867792e28e37969383518220fc.jpg",
          },
          {
            title: "Jap Malas",
            slug: "jap-malas",
            image:
              "https://i.pinimg.com/1200x/b2/78/fa/b278faa49e324660533bb48f03cc73c0.jpg",
          },
          {
            title: "Bracelets",
            slug: "bracelets",
            image:
              "https://i.pinimg.com/1200x/30/af/e1/30afe18c84adab709d6baf389dc62537.jpg",
          },
         
          {
            title: "Wooden Products",
            slug: "wooden-products",
            image:
              "https://i.pinimg.com/1200x/7b/09/7c/7b097cd9742c6e83f421d7c7cfe9b72a.jpg",
          },
        ],
      },
      //  10 Shop By Concern
      {
        title: "Shop By Concern",
        slug: "shop-by-concern",
        icon: "https://i.pinimg.com/736x/f9/fb/ee/f9fbee9f69080ff2a1cdbd6856f915a9.jpg",

        items: [
          {
            title: "Career & Business Growth",
            slug: "career-business-growth",
            image:
              "https://i.pinimg.com/1200x/d8/17/91/d81791d1b9bae2e89c32e70d222427f0.jpg",
          },
          {
            title: "Health & Vitality",
            slug: "health-vitality",
            image:
              "https://i.pinimg.com/1200x/3b/64/9d/3b649d8b4c65e7a4a83803a6571c8a12.jpg",
          },
          {
            title: "Marriage & Relationships",
            slug: "marriage",
            image:
              "https://i.pinimg.com/736x/20/de/36/20de362cc393fe3c0210ff9b0f69b68c.jpg",
          },
          {
            title: "Education & Concentration",
            slug: "education",
            image:
              "https://i.pinimg.com/736x/82/32/92/82329263e593c7bb2c0ab5b5fff8a71c.jpg",
          },
          {
            title: "Wealth & Prosperity",
            slug: "wealth",
            image:
              "https://i.pinimg.com/1200x/0c/fa/3b/0cfa3b73452173d269dad48b6263c284.jpg",
          },
          {
            title: "Evil Eye & Protection",
            slug: "protection",
            image:
              "https://i.pinimg.com/1200x/5d/a5/e0/5da5e0801001f0aa72ff1ce40d3ce95a.jpg",
          },
        ],
      },
      // 11 Shop By Astrology
      {
        title: "Shop By Astrology",
        slug: "shop-by-astrology",
        icon: "https://i.pinimg.com/736x/21/52/48/215248170a80b6780679ab236b477c12.jpg",

        items: [
          {
            title: "Aries",
            slug: "aries",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785840664/aries_zhe2da.png",
          },
          {
            title: "Taurus",
            slug: "taurus",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785840665/taurus_pompp4.png",
          },
          {
            title: "Gemini",
            slug: "gemini",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785840664/gemini_o8apvj.png",
          },
          {
            title: "Cancer",
            slug: "cancer",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785840664/cancer_se2lb1.png",
          },
          {
            title: "Leo",
            slug: "leo",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785840665/leo_yndx3d.png",
          },
          {
            title: "Virgo",
            slug: "virgo",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785840664/virgo_kgdsgh.png",
          },
          {
            title: "Libra",
            slug: "libra",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785840664/Libra_gy98np.png",
          },
          {
            title: "Scorpio",
            slug: "scorpio",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785840665/Scorpio_docqcj.png",
          },
          {
            title: "Sagittarius",
            slug: "sagittarius",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785840665/Sagittarius_bxdjak.png",
          },
          {
            title: "Capricorn",
            slug: "capricorn",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785840666/Capricorn_fvl2yj.png",
          },
          {
            title: "Aquarius",
            slug: "aquarius",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785840663/Aquarius_j2hxih.png",
          },
          {
            title: "Pisces",
            slug: "pisces",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785840665/Pisces_tkx1xo.png",
          },
        ],
      },
      // 12 Shop By Birth Number / Mulank
      {
        title: "Shop By Birth Number / Mulank",
        slug: "shop-by-birth-number",
        icon: "https://i.pinimg.com/1200x/90/da/5b/90da5b31c2c932d8218d3180cd8a1963.jpg",

        items: [
          {
            title: "Number 1",
            slug: "number-1",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785909894/a4313bc6-80c9-465e-92c4-692730ae966c_efvob6.png",
          },
          {
            title: "Number 2",
            slug: "number-2",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785909894/cc304903-5999-4bdf-9f48-80a90f30627f_huloa5.png",
          },
          {
            title: "Number 3",
            slug: "number-3",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785910086/0e3449f0-9562-41c5-84dd-90d8c3576ab7_ovh1ij.png",
          },
          {
            title: "Number 4",
            slug: "number-4",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785911125/38787e7b-f238-4502-b6be-49c2bf9d7d7c_hekxyq.png",
          },
          {
            title: "Number 5",
            slug: "number-5",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785911238/a9d36b54-3776-4ed8-89e3-8494a2b8ffa6_p0cyqt.png",
          },
          {
            title: "Number 6",
            slug: "number-6",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785911307/6ea54f94-e4e7-4cee-9463-2c5cfcaeabef_vx6fso.png",
          },
          {
            title: "Number 7",
            slug: "number-7",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785911395/f0290cb2-9e22-4c9a-84d6-394f7c3d37a2_yp9ndq.png",
          },
          {
            title: "Number 8",
            slug: "number-8",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785911465/24611cfd-4591-4886-8321-787a3bef6681_afif8j.png",
          },
          {
            title: "Number 9",
            slug: "number-9",
            image:
              "https://res.cloudinary.com/dbb2hkjri/image/upload/v1785911536/9d88dda1-b88a-452e-922e-b5287ecd8118_tulqs3.png",
          },
        ],
      },
      // 13 Product On Demand
      {
        title: "Product On Demand",
        slug: "product-on-demand",
        link: "/product-on-demand",
        icon: "https://i.pinimg.com/1200x/e1/2f/c1/e12fc192c5177766be8b5d71797dd1ab.jpg",
        items: [
          {
            title: "Custom Rudraksha Combination",
            slug: "custom-rudraksha",
            link: "/product-on-demand?category=rudraksha",
            image:
              "https://i.pinimg.com/1200x/22/60/f1/2260f131bee4b8d0e9e9abdc25ac9d55.jpg",
          },
          {
            title: "Custom Gemstone Jewelry",
            slug: "custom-gemstone",
            link: "/product-on-demand?category=gemstone",
            image:
              "https://i.pinimg.com/1200x/2b/20/ed/2b20ed4021922a6d3248f384a85859b7.jpg",
          },
          {
            title: "Personalized Puja & Rituals",
            slug: "custom-puja",
            link: "/product-on-demand?category=puja",
            image:
              "https://i.pinimg.com/1200x/f2/7a/49/f27a49d9b522e98d25a276a08c77701e.jpg",
          },
          {
            title: "Bespoke Yantra & Murtis",
            slug: "custom-yantra",
            link: "/product-on-demand?category=yantra",
            image:
              "https://i.pinimg.com/1200x/c0/8f/6e/c08f6e8bae54309b0eb22ea9daeac149.jpg",
          },
          {
            title: "Custom Fragrances & Ittars",
            slug: "custom-fragrance",
            link: "/product-on-demand?category=fragrance",
            image:
              "https://i.pinimg.com/736x/7b/a7/5d/7ba75d25419496c0b51877e280e0da26.jpg",
          },
          {
            title: "Tailored Vastu Remedies",
            slug: "custom-vastu",
            link: "/product-on-demand?category=vastu",
            image:
              "https://i.pinimg.com/1200x/a4/a7/c5/a4a7c566132d7be6e5b3356a32e27cd3.jpg",
          },
        ],
      },
    ],
  },
  {
    title: "Consultations Offered",
    link: "/consultation",
  },
  {
    title: "Blog",
    link: "/Blog",
  },
  {
    title: "Contact Us",
    link: "/contact",
  },
   
];

export default menuData;
